
import React from "react";
import OpportunityCard from "./OpportunityCard";
import { Opportunity } from "@/types/database-extensions";
import { Button } from "@/components/ui/button";
import { Plus } from "lucide-react";
import { User } from "@supabase/supabase-js";

interface OpportunitiesListProps {
  opportunities: Opportunity[];
  loading: boolean;
  onPostOpportunity: () => void;
  onDelete?: (id: string) => Promise<void>;
  currentUser?: User | null;
}

const OpportunitiesList: React.FC<OpportunitiesListProps> = ({
  opportunities,
  loading,
  onPostOpportunity,
  onDelete,
  currentUser
}) => {
  if (loading) {
    return (
      <div className="grid gap-6 grid-cols-1 md:grid-cols-2 lg:grid-cols-3">
        {[1, 2, 3].map(i => (
          <div key={i} className="bg-muted h-64 rounded-lg animate-pulse"></div>
        ))}
      </div>
    );
  }

  if (opportunities.length === 0) {
    return (
      <div className="text-center py-12 bg-muted/50 rounded-lg">
        <h3 className="text-xl font-medium mb-2">No opportunities found</h3>
        <p className="text-muted-foreground mb-6">
          Be the first to post an opportunity!
        </p>
        <Button onClick={onPostOpportunity}>
          <Plus size={16} className="mr-2" /> Post Opportunity
        </Button>
      </div>
    );
  }

  return (
    <div className="grid gap-6 grid-cols-1 md:grid-cols-2 lg:grid-cols-3">
      {opportunities.map(opportunity => (
        <OpportunityCard 
          key={opportunity.id} 
          opportunity={opportunity} 
          onDelete={onDelete}
          canDelete={!!currentUser && currentUser.id === opportunity.user_id}
        />
      ))}
    </div>
  );
};

export default OpportunitiesList;
